import { useWatch } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { CommunityMemberPicker } from "@circle-react-shared/CommunityMemberPicker";
import { FormItem } from "../../../Common/FormItem";
import { MembersPreview } from "../MembersPreview";

interface InvitedEntityIds {
  member_tags_ids: number[];
  members_ids: number[];
  space_groups_ids: number[];
  spaces_ids: number[];
}

const DEFAULT_INVITED_ENTITY_IDS: InvitedEntityIds = {
  members_ids: [],
  member_tags_ids: [],
  space_groups_ids: [],
  spaces_ids: [],
};

export const Attendees = () => {
  const invitedEntityIds =
    useWatch<{ invited_entities_ids: InvitedEntityIds }>({
      name: "invited_entities_ids",
    }) || DEFAULT_INVITED_ENTITY_IDS;
  const {
    spaces_ids: spaceIds,
    space_groups_ids: spaceGroupIds,
    member_tags_ids: memberTagIds,
    members_ids: memberIds,
  } = invitedEntityIds as InvitedEntityIds;
  const areInvitedEntitiesSelected = Object.values(invitedEntityIds).some(
    value => !!value?.length,
  );
  const buttonLabel = areInvitedEntitiesSelected ? t("manage") : t("invite");

  return (
    <>
      <FormItem name="invited_entities_ids" className="z-20 mb-6" hideLabel>
        <CommunityMemberPicker
          name="invited_entities_ids"
          rules={{
            required: false,
          }}
          onModalSave={() => {}}
          onModalClose={() => {}}
          variant="modal"
          countLabel={t("live_streams.form.members_invited_label")}
          tooltipText={t("live_streams.form.members_invited_tooltip")}
          selectionLabel={t(
            "live_streams.form.members_invited_selection_label",
          )}
          searchPlaceholder={t("live_streams.form.members_invited_placeholder")}
          buttonLabel={buttonLabel}
          includeAllResultTypes
        />
      </FormItem>
      <MembersPreview
        spaceIds={spaceIds}
        spaceGroupIds={spaceGroupIds}
        memberTagIds={memberTagIds}
        memberIds={memberIds}
      />
    </>
  );
};
